import script from "./ProfileSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSection.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileSection.vue?vue&type=style&index=0&id=52d4c4ee&lang=postcss&scoped=true"

import exportComponent from "/home/runner/work/matchd-frontend/matchd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52d4c4ee"]])

export default __exports__